// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"157":"61e1b912","472":"b75597d9","863":"c3cdcfde"}[chunkId] + ".chunk.js";
};